import {
  Controller,
  type Control,
  type FieldErrors,
  type UseFormRegister,
} from 'react-hook-form';
import type { AddResidentData } from '../AddResidentForm';
import { Dropdown, Input } from '@/shared';
import { useHousesList } from '@/features/houses/hooks/useHouseQueries';

// ---------------------------- Step 2 ----------------------------

interface HouseAssignmentProps {
  control: Control<AddResidentData>;
  register: UseFormRegister<AddResidentData>;
  errors: FieldErrors<AddResidentData>;
}

export const ResidentHouseAssignmentForm: React.FC<HouseAssignmentProps> = ({
  control,
  register,
  errors,
}) => {
  const { data: housesList } = useHousesList();

  const houseOptions =
    housesList?.map((item) => ({
      label: item.name,
      value: item.id,
    })) ?? [];

  return (
    <>
      <Controller
        name="houseId"
        control={control}
        render={({ field }) => (
          <Dropdown
            label="Select House"
            options={houseOptions}
            value={field.value}
            buttonClassName="!w-full"
            onChange={field.onChange}
          />
        )}
      />
      {errors.houseId && (
        <p className="text-red-500">{errors.houseId.message}</p>
      )}

      <Controller
        name="bedNumber"
        control={control}
        render={({ field }) => (
          <Input
            label="Bed Number"
            placeholder="Enter Bed Number"
            value={field.value}
            onChange={field.onChange}
            className="!w-full"
          />
        )}
      />

      <Input
        label="Move-in Date"
        type="date"
        {...register('moveInDate')}
        error={errors.moveInDate?.message}
      />
    </>
  );
};
